package com.milta.core.localization.translations.fr

import com.milta.core.localization.SubscriptionExpiredStrings

internal val SubscriptionExpired = SubscriptionExpiredStrings(
    title = "Abonnement expiré",
    driverSoloMessage = "Votre abonnement a expiré. Renouvelez pour continuer.",
    patronMessage = "Votre abonnement a expiré. Votre équipe ne peut plus accéder à Milta.",
    driverUnderPatronMessage = "L'abonnement de votre Entreprise a expiré. Contactez votre Entreprise pour rétablir votre accès.",
    renewButton = "Renouveler",
    close = "Fermer",
    subscribeButtonTemplate = "S'abonner pour %s",
    driverLinkCodeHint = "Vous travaillez pour une Entreprise ? Transmettez-lui ce code : une fois rattaché, vous êtes couvert par son abonnement.",
    checkAccessButton = "Vérifier mon accès",
    accessStillUnavailable = "Accès toujours indisponible",
)
